import { TabsProps } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';

import { Tabs } from 'components/common';

import { orgApi } from '../../modules/organization/organizationApi';
import { useOrganization } from '../../modules/organization/useOrganization';
import { usePerformance } from '../../modules/performance/usePerformance';
import { localStorageService } from '../../services/localStorage';
import {
  DSP_ADFORM,
  DSP_AMAZON,
  DSP_CRITEO,
  DSP_FREEWHEEL,
  DSP_LABELS,
  DSP_VISTAR,
  DSP_XANDR,
} from '../../utils/constants';

export const DspTabs = () => {
  const { dsp, setDsp } = useOrganization();
  const { pickSelectedDimensions } = usePerformance();

  const [showVistar, setShowVistar] = useState<boolean>(false);
  const [showCriteo, setShowCriteo] = useState<boolean>(false);
  const [showAdform, setShowAdform] = useState<boolean>(false);
  const [showAmazon, setShowAmazon] = useState<boolean>(false);
  const [showFreewheel, setShowFreewheel] = useState<boolean>(false);

  const checkDspAgencies = async (dspType: string, setShowFunction: (show: boolean) => void) => {
    try {
      const agencies = await orgApi.getAgencies(dspType);
      const allEmpty = agencies.every(
        (agency) => !agency.advertisers || agency.advertisers.length === 0,
      );

      setShowFunction(!allEmpty);
    } catch (error) {
      setShowFunction(false);
    }
  };

  useEffect(() => {
    checkDspAgencies(DSP_VISTAR, setShowVistar);
    checkDspAgencies(DSP_CRITEO, setShowCriteo);
    checkDspAgencies(DSP_ADFORM, setShowAdform);
    checkDspAgencies(DSP_AMAZON, setShowAmazon);
    checkDspAgencies(DSP_FREEWHEEL, setShowFreewheel);
  }, []);

  const handleTabChange = (key: string) => {
    pickSelectedDimensions([null, null]);
    setDsp(key);
    localStorageService.setItem('currentDsp', key);
  };

  const tabItems: TabsProps['items'] = useMemo(() => {
    const baseTabs = [];

    if (showAdform) {
      baseTabs.push({ key: DSP_ADFORM, label: 'Adform' });
    }
    if (showAmazon) {
      baseTabs.push({ key: DSP_AMAZON, label: 'Amazon' });
    }
    if (showFreewheel) {
      baseTabs.push({ key: DSP_FREEWHEEL, label: DSP_LABELS[DSP_FREEWHEEL] });
    }
    baseTabs.push({ key: DSP_XANDR, label: 'Xandr' });
    if (showVistar) {
      baseTabs.push({ key: DSP_VISTAR, label: 'Vistar' });
    }
    if (showCriteo) {
      baseTabs.push({ key: DSP_CRITEO, label: 'Criteo' });
    }

    return baseTabs;
  }, [showVistar, showCriteo, showAdform, showAmazon, showFreewheel]);

  return (
    <Tabs
      className="ctv-tabs--bottom-marker"
      items={tabItems}
      onChange={handleTabChange}
      activeKey={dsp ?? DSP_XANDR}
    />
  );
};
